import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_DOMAIN_USAGE_SNAPSHOT = 'FETCH_ANALYTIC_DOMAIN_USAGE_SNAPSHOT';
export const fetchAnalyticDomainUsageSnapshotAction = createAction(FETCH_ANALYTIC_DOMAIN_USAGE_SNAPSHOT);